module.exports = __webpack_public_path__ + "img/87c68452f4b342b9ad8f3a87ad491e39-640.50c5466b.png";